import { useState, useEffect } from 'react';

/**
 * Tracks viewport width with rAF-throttled resize.
 * Breakpoints (reference SPEC §1.7): mobile ≤720 · tablet 721–1080 · desktop >1080.
 */
export function useViewport() {
  const [w, setW] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1280));
  useEffect(() => {
    let raf = null;
    const onResize = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; setW(window.innerWidth); });
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return { width: w, isMobile: w <= 720, isTablet: w > 720 && w <= 1080 };
}
